/**
 * @module framework/directives/focus
 */

import { Directive } from 'vue';

import { App } from '~/framework/vue';

const focusDirective: Directive<HTMLElement> = {
	// When the bound element is inserted into the DOM...
	mounted($element, { value }) {
		// Focus the element
		if (value) $element.focus();
	},
};

// https://vuejs.org/v2/guide/custom-directive.html
// Register a global custom directive called `v-focus`
export const focus = (app: App<HTMLElement>) => {
	app.directive('focus', focusDirective);
};
